type Props = {
  text: string;
};

export default function Title({ text }: Props) {
  return (
    <div
      data-cy="wtb-title"
      className="flex items-center justify-between text-lg font-bold tracking-wide text-black"
    >
      {text}
    </div>
  );
}
